module.exports = __webpack_public_path__ + "img/morale+productvt-min.c0772dd7.jpg";